// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".yhuhCLSR {\n  display: 'flex';\n  flex-direction: 'row'; }\n", "",{"version":3,"sources":["webpack://./src/users/relationField.scss"],"names":[],"mappings":"AAGA;EACE,eAAe;EACf,qBAAqB,EAAA","sourcesContent":[".relationFieldEntry {\n}\n\n.relationContainer {\n  display: 'flex';\n  flex-direction: 'row';\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"relationContainer": "yhuhCLSR"
};
export default ___CSS_LOADER_EXPORT___;
